<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Transacción</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if(transaction){
  <ion-grid fixed>
    <ion-row>
      <ion-col *ngIf="created" size="12">
        <ion-item lines="none">
          <ion-label>
            <p class="ion-text-center">Creado el {{ created | date : 'dd/MM/yyyy HH:mm' }}</p>
          </ion-label>
        </ion-item>
        <!-- mostrar numero de operacion transaction id or casino sportsbook id -->
        <ion-item lines="none">
          <ion-label>
            <p>Número de operación</p>
            <p>
              @if (transaction.data.product === 'book') {
              <strong>
                {{ transaction.data.payload.ticketNumber || transaction.data.payload.idWager }}
              </strong>
              } @else if (transaction.data.product === 'casino') {
              <strong>
                {{ transaction.data.payload.roundId }}
              </strong>
              } @else {
              <strong>
                {{ transaction.uid }}
              </strong>
              }
            </p>
          </ion-label>
          <!-- <ion-icon slot="end" name="copy-outline"></ion-icon> -->
        </ion-item>
        <ion-item *ngIf="transaction.data?.confirm?.payload && transaction.status === 'completed'" lines="none" button>
          <ion-label>
            <p>No. de transacción</p>
            <p *ngIf="transaction.data?.confirm?.payload as payload">
              <strong>{{ payload.TransactionID }}</strong>
            </p>
          </ion-label>
        </ion-item>

        <ion-item *ngIf="transaction.data?.refereeName" lines="none">
          <ion-label>
            <p>Usuario referido</p>
            <p>
              <strong>{{ transaction.data.refereeName }}</strong>
            </p>
          </ion-label>
        </ion-item>
        <!-- mostrar tipo de transaction y status -->
        @if(transaction.data.product !== 'casino' && transaction.data.product !== 'book' ){
        <ion-item lines="none" button>
          <ion-label>
            <p>{{ 'transaction.type.' + type | translate }}</p>
            <p>
              <strong>{{ 'transaction.status.' + (refund ? 'cancelled' : transaction.status) | translate }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }
        <!-- mostrar la info de sportsbook -->
        @else if(transaction.data.product === 'book' && (transaction.type.includes('purchase') ||
        transaction.type.includes('prize')) && (transaction.data.payload?.Details?.length ||
        transaction.data.wager?.Details?.length)) {

        <!-- Tipo de apuesta (PARLAY / STRAIGHT BET) -->
        <ion-item lines="none">
          <ion-label>
            <p>Tipo de apuesta</p>
            <p>
              <strong>{{ bookBetType }}</strong>
            </p>
          </ion-label>
          <ion-badge slot="end" [color]="bookBetResult.color">
            {{ bookBetResult.label }}
          </ion-badge>
        </ion-item>

        <!-- Deporte -->
        <ion-item lines="none">
          <ion-label>
            <p>Deporte</p>
            <p>
              <strong>{{ bookWaggers[0].sportName }}</strong>
            </p>
          </ion-label>
        </ion-item>

        <!-- Momios totales / Odds -->
        @if(bookWaggers.length === 1) {
        <ion-item lines="none">
          <ion-label>
            <p>Momios</p>
            <p>
              <strong>{{ bookWaggers[0].odds > 0 ? '+' : '' }}{{ bookWaggers[0].odds }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }

        <!-- Monto apostado -->
        @if(bookRiskAmount !== null) {
        <ion-item lines="none">
          <ion-label>
            <p>Monto apostado</p>
            <p>
              <strong>{{ bookRiskAmount | currency }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }

        <!-- Ganancia posible -->
        @if(bookWinAmount !== null) {
        <ion-item lines="none">
          <ion-label>
            <p>Ganancia posible</p>
            <p>
              <strong>{{ bookWinAmount | currency }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }

        <!-- Detalle de eventos (expandible) -->
        <ion-accordion-group class="book-details-accordion">
          <ion-accordion value="book-events">
            <ion-item slot="header" color="light">
              <ion-label>
                <strong>Detalle de eventos ({{ bookWaggers.length }})</strong>
              </ion-label>
            </ion-item>
            <div slot="content" class="book-events-content">
              @for (detail of bookWaggers; track $index) {
              <ion-card class="book-event-card">
                <ion-card-header class="book-event-header">
                  <ion-card-subtitle>
                    <ion-icon name="calendar-outline"></ion-icon>
                    {{ formatBookDateTime(detail.GameDateTime) }}
                  </ion-card-subtitle>
                  <ion-card-title class="book-event-title">
                    {{ getBookDetailEventDescription(detail) }}
                  </ion-card-title>
                </ion-card-header>
                <ion-card-content class="book-event-body">
                  <ion-grid class="ion-no-padding">
                    <ion-row>
                      <ion-col size="6">
                        <p class="book-detail-label">Deporte</p>
                        <p class="book-detail-value">{{ detail.sportName }}</p>
                      </ion-col>
                      <ion-col size="6">
                        <p class="book-detail-label">Período</p>
                        <p class="book-detail-value">{{ detail.period }}</p>
                      </ion-col>
                    </ion-row>
                    <ion-row>
                      <ion-col size="6">
                        <p class="book-detail-label">Selección</p>
                        <p class="book-detail-value">
                          <strong>{{ detail.completeTeamDescription }}</strong>
                        </p>
                      </ion-col>
                      <ion-col size="6">
                        <p class="book-detail-label">Momios</p>
                        <p class="book-detail-value">
                          <ion-badge [color]="detail.odds > 0 ? 'success' : 'danger'">
                            {{ detail.odds > 0 ? '+' : '' }}{{ detail.odds }}
                          </ion-badge>
                        </p>
                      </ion-col>
                    </ion-row>
                    @if(detail.points && detail.points !== 0) {
                    <ion-row>
                      <ion-col size="6">
                        <p class="book-detail-label">Puntos</p>
                        <p class="book-detail-value">{{ detail.points }}</p>
                      </ion-col>
                      <ion-col size="6">
                        <p class="book-detail-label">Línea</p>
                        <p class="book-detail-value">{{ detail.lineDescription }}</p>
                      </ion-col>
                    </ion-row>
                    }
                  </ion-grid>
                </ion-card-content>
              </ion-card>
              }
            </div>
          </ion-accordion>
        </ion-accordion-group>
        }
        <!-- metodo de pago (nuvei) -->
        @if(transaction.data?.save?.method){
        <ion-item *ngIf="transaction.data?.save?.method" lines="none" button>
          <!-- <ion-icon *ngIf="type === 'purchase'" slot="start" name="wallet-outline"></ion-icon> -->
          <ion-label>
            <p>Metodo de pago</p>
            <p *ngIf="transaction.data?.save?.method">
              <strong>{{ 'method.' + transaction.data?.save?.method | translate }}</strong>
              <span *ngIf="transaction.data?.confirm?.payload as payload">
                <span *ngIf="payload.payment_method === 'cc_card'">{{ payload.pmDisplayName }}</span>
                <span *ngIf="payload.payment_method === 'apmgw_PayCash'">{{ payload.externalTransactionId }}</span>
                <span *ngIf="payload.payment_method === 'apmgw_STPmex'"
                  >{{ payload.pmDisplayName[0] }}****{{ payload.pmDisplayName.slice(14) }}</span
                >
              </span>
            </p>
          </ion-label>
        </ion-item>
        } @if( transaction.type.includes('purchase')){
        <!-- <ion-item lines="none">
          <ion-label>
            <p>Producto</p>
            <p>
              <strong>{{ 'game.' + transaction.type.split('wallet-purchase-').pop() | translate }}</strong>
            </p>
          </ion-label>
        </ion-item> -->
        <!-- mostrar numero de billete si es tradicional -->
        @if(isTradicional && tickets.length){ @for(ticket of tickets; track ticket.idTransaccion){ @for(b of
        ticket.billete; track $index) {
        <ion-item lines="none">
          <ion-label>
            @if(b.signo !== undefined && b.signo !== 0){
            <p>{{ getZodiacName(b.signo) }}</p>
            }
            <h2>
              @for(d of getDigits(b.numeroBillete, ticket.drawType || ''); track $index;){
              <ion-badge color="medium">{{ d }}</ion-badge>
              }
            </h2>
          </ion-label>
          @if(b.signo !== undefined && b.signo !== 0){
          <ion-icon slot="end" [src]="getZodiacIcon(b.signo)"></ion-icon>
          }
        </ion-item>
        } } } @else if(!isTradicional && tickets.length && product !=='Tris' && product !== 'Protouch' &&
        !product.includes('Progol')){ @for(ticket of tickets; track $index){
        <ion-item lines="none">
          <ion-label>
            <h2>
              @if(product === 'GanaGato'){
              <p>
                @for(d of ticket.value | slice:0:3; track $index;){
                <ion-badge color="medium">{{ d }}</ion-badge>
                }
              </p>
              <p>
                <ion-badge color="medium">{{ ticket.value[3] }}</ion-badge>
                <ion-badge color="medium">$</ion-badge>
                <ion-badge color="medium">{{ ticket.value[4] }}</ion-badge>
              </p>
              <p>
                @for(d of ticket.value | slice:-3; track $index;){
                <ion-badge color="medium">{{ d }}</ion-badge>
                }
              </p>
              }@else{ @for(d of ticket.value; track $index;){
              <ion-badge color="medium">{{ d }}</ion-badge>
              } }
            </h2>
          </ion-label>
        </ion-item>

        } } @else if(!isTradicional && tickets.length && product ==='Tris'){ @for(ticket of tickets; track $index){
        <ion-item lines="none">
          <ion-label>
            <p>{{ ticket.price.name }}</p>
            <h2>
              @for(d of ticket.value; track $index;){
              <ion-badge color="medium">{{ d < 0 ? 'X' : d }}</ion-badge>
              }
            </h2>
          </ion-label>
          <ion-label slot="end">
            @if(ticket.ticketAmount){
            <p>
              <span>Monto: ${{ ticket.ticketAmount }}</span>
            </p>
            } @if(ticket.multiplicadorAmount){
            <p>
              <span>Mult: x{{ ticket.multiplicadorAmount }}</span>
            </p>
            }
          </ion-label>
        </ion-item>

        } } @else if(!isTradicional && tickets.length && product ==='Protouch'){ @for(ticket of tickets; track $index){
        <ion-item lines="none">
          <ion-label>
            <h2>
              @for(d of ticket; track $index){
              <ion-badge color="medium">
                @for(s of d.selected; track $index;) {
                {{ s[0] | uppercase }}
                }
              </ion-badge>
              }
            </h2>
          </ion-label>
          <ion-label slot="end">
            <h2>{{ 'protouch.' + touches[$index] | translate }}</h2>
          </ion-label>
        </ion-item>
        } } @else if(!isTradicional && tickets.length && product ==='ProgolMediaSemana'){ @for(ticket of tickets; track
        $index){
        <ion-item lines="none">
          <ion-label>
            <h2>
              @for(d of ticket; track $index){
              <ion-badge color="medium">
                @for(s of d.selected; track $index;) {
                {{ s[0] | uppercase }}
                }
              </ion-badge>
              }
            </h2>
          </ion-label>
        </ion-item>
        } } @else if(!isTradicional && tickets.length && product ==='ProgolMediaSemana'){ @for(ticket of tickets; track
        $index){
        <ion-item lines="none">
          <ion-label>
            <h2>
              @for(d of ticket; track $index){
              <ion-badge color="medium">
                @for(s of d.selected; track $index;) {
                {{ (s[0] === 'd' ? 'e' : s[0]) | uppercase }}
                }
              </ion-badge>
              }
            </h2>
            3
          </ion-label>
        </ion-item>
        } } @else if(!isTradicional && tickets.length && product ==='Progol'){ @for(ticket of tickets |
        slice:0:tickets.length/2; track $index){
        <ion-item lines="none">
          <ion-label>
            <h2>
              @for(d of ticket; track $index){
              <ion-badge color="medium">
                @for(s of d.selected; track $index;) {
                {{ (s[0] === 'd' ? 'e' : s[0]) | uppercase }}
                }
              </ion-badge>
              }
            </h2>
          </ion-label>
        </ion-item>
        @if(tickets[tickets.length / 2 + $index].length) {

        <ion-item lines="none">
          <ion-label>
            <h2>
              @for(d of tickets[tickets.length / 2 + $index]; track $index){
              <ion-badge color="medium">
                @for(s of d.selected; track $index;) {
                {{ (s[0] === 'd' ? 'e' : s[0]) | uppercase }}
                }
              </ion-badge>
              }
            </h2>
          </ion-label>
          <ion-label slot="end">
            <p>Rev</p>
          </ion-label>
        </ion-item>
        } } } }
        <!-- Monto genérico (excluye book con Details ya que se muestra arriba) -->
        @if(!(transaction.data.product === 'book' && (transaction.type.includes('purchase') ||
        transaction.type.includes('prize')) && (transaction.data.payload?.Details?.length ||
        transaction.data.wager?.Details?.length))) {
        <ion-item lines="none">
          <ion-label>
            <p>
              {{
                transaction.data.product === 'book' || transaction.data.product === 'casino'
                  ? transaction.type.includes('purchase')
                    ? 'Monto apostado'
                    : transaction.type.includes('refund')
                    ? transaction.type.includes('reversal')
                      ? 'Monto descontado'
                      : 'Monto devuelto'
                    : transaction.type.includes('prize')
                    ? transaction.type.includes('reversal')
                      ? 'Monto descontado'
                      : 'Monto ganado'
                    : 'Monto'
                  : 'Monto'
              }}
            </p>
            <p>
              <strong>{{ transaction.amount | currency }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }
        <!-- Monto apostado SB en premios (solo si no tiene Details detallados) -->
        @if( transaction.data.product === 'book' && transaction.type.includes('prize') && sbStake &&
        !(transaction.data.payload?.Details?.length || transaction.data.wager?.Details?.length)) {
        <ion-item lines="none">
          <ion-label>
            <p>Monto apostado (SB)</p>
            <p>
              <strong>{{ sbStake | currency }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }

        <!-- monto a ganar (solo si no tiene Details detallados) -->
        @if(transaction.data.product === 'book' && transaction.data.payload?.winAmount &&
        !(transaction.data.payload?.Details?.length || transaction.data.wager?.Details?.length)) {
        <ion-item lines="none">
          <ion-label>
            <p>Monto a ganar</p>
            <p>
              <strong>{{ transaction.data.payload.winAmount | currency }}</strong>
            </p>
          </ion-label>
        </ion-item>

        }
        <!-- juego (casino) -->
        @if(transaction.data.product === 'casino'){
        <ion-item lines="none">
          <ion-label>
            <p>Juego</p>
            <p>
              <strong>{{ transaction.data.payload.game }}</strong>
            </p>
          </ion-label>
        </ion-item>
        } @if(transaction.data.reason) {
        <ion-item lines="none">
          <ion-label>
            <p>Razón</p>
            <h2>{{ transaction.data.reason }}</h2></ion-label
          >
        </ion-item>
        } @if(reason) {
        <ion-item lines="none">
          <ion-label>
            <p>{{ 'transaction.reason' | translate }}</p>
            <p>
              <strong>{{ reason }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }
        <!-- mostrar description si no es sportsbook or casino -->
        @if(transaction.data.product !== 'book' && (transaction.data.payload?.description ||
        transaction.data.wager?.description)) {
        <ion-item lines="none">
          <ion-label>
            <p>{{ 'transaction.description' | translate }}</p>
            <p>
              <strong>{{ transaction.data.payload?.description || transaction.data.wager?.description }}</strong>
            </p>
          </ion-label>
        </ion-item>
        }
        <!-- detalles de mosntos -->
        @if(transaction.status === 'completed' || (transaction.type === "wallet_withdrawal_user" && (transaction.status
        === 'cancelled' || transaction.status === 'declined'))){
        <ion-accordion-group>
          <ion-accordion value="first">
            <ion-item slot="header" color="light">
              <ion-label>Resumen saldos</ion-label>
            </ion-item>
            <div class="ion-padding" slot="content">
              <ion-card>
                @if(selected === 'loteria' && (balanceStart || balanceEnd)) {
                <ion-item lines="none" button>
                  <ion-label
                    ><p>Saldo anterior</p>
                    <p>
                      <strong>{{ balanceStart | currency }}</strong>
                    </p></ion-label
                  >
                </ion-item>
                <ion-item lines="none" button>
                  <ion-label
                    ><p>Saldo final</p>
                    <p>
                      <strong>{{ balanceEnd | currency }}</strong>
                    </p></ion-label
                  >
                </ion-item>
                } @if((selected === 'loteria' || selected === 'award') && (awardBalanceStart || awardBalanceEnd)) {
                <ion-item lines="none" button>
                  <ion-label
                    ><p>Saldo anterior (Premios)</p>
                    <p>
                      <strong>{{ awardBalanceStart | currency }}</strong>
                    </p></ion-label
                  >
                </ion-item>
                <ion-item lines="none" button>
                  <ion-label
                    ><p>Saldo final (Premios)</p>
                    <p>
                      <strong>{{ awardBalanceEnd | currency }}</strong>
                    </p></ion-label
                  >
                </ion-item>
                } @if((selected === 'loteria' || selected === 'bonus') && (bonusBalanceStart || bonusBalanceEnd)) {
                <ion-item lines="none" button>
                  <ion-label
                    ><p>Saldo anterior (Bonos)</p>
                    <p>
                      <strong>{{ bonusBalanceStart | currency }}</strong>
                    </p></ion-label
                  >
                </ion-item>
                <ion-item lines="none" button>
                  <ion-label
                    ><p>Saldo final (Bonos)</p>
                    <p>
                      <strong>{{ bonusBalanceEnd | currency }}</strong>
                    </p></ion-label
                  >
                </ion-item>
                }
              </ion-card>
            </div>
          </ion-accordion> </ion-accordion-group
        >}

        <ion-item *ngIf="transaction.match && transaction.match.length < 10" lines="none" button>
          <ion-label
            ><p>Detalle del premio:</p>
            <p *ngFor="let match of transaction.match">
              <strong> {{ getName(transaction.data.product) }} {{ match.drawNumber }}: </strong> {{ match.folio }} ({{
                match.tipoPremio | slice : 0 : 1
              }})
              {{ match.neto | currency }}
            </p></ion-label
          >
        </ion-item>

        <ion-item *ngIf="transaction.match && transaction.match.length > 10" lines="none" button>
          <ion-label
            ><p>Detalle del premio: {{ getName(transaction.data.product) }}</p>
            <p>
              <strong>Revisa el detalle de este premio en <a (click)="gotoHistory()">"Mis boletos"</a></strong>
            </p></ion-label
          >
        </ion-item>
        @if(transaction.status === 'completed' && type === 'purchase' && !refund && !transaction.type.includes('casino')
        && !transaction.type.includes('book')){
        <ion-item lines="none" button (click)="goToPurchase(transaction)">
          <ion-label>Ver comprobante</ion-label>
          <ion-icon slot="end" name="arrow-forward"></ion-icon>
        </ion-item>
        } @if(transaction.status === 'completed' && type === 'prize' && transaction.purchase && !refund){
        <ion-item lines="none" button (click)="goToPurchase(transaction)">
          <ion-label>Ver boleto</ion-label>
          <ion-icon slot="end" name="arrow-forward"></ion-icon>
        </ion-item>
        } @if((transaction.status === 'declined' || transaction.status === 'cancelled') && transaction.data.returnAmount
        === false) {
        <ion-item lines="none" button (click)="payoutReviver(transaction)">
          <ion-label>Reactivar retiro</ion-label>
          <ion-icon slot="end" name="arrow-undo-outline"></ion-icon>
        </ion-item>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
  }
</ion-content>
